import { render, staticRenderFns } from "./17zhihuizhengwu.vue?vue&type=template&id=3b3e949a&scoped=true&"
import script from "./17zhihuizhengwu.vue?vue&type=script&lang=js&"
export * from "./17zhihuizhengwu.vue?vue&type=script&lang=js&"
import style0 from "./17zhihuizhengwu.vue?vue&type=style&index=0&id=3b3e949a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3e949a",
  null
  
)

export default component.exports